import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
//Router-dom
import { Link } from 'react-router-dom';

import { basicMsg } from "../../actions/swal_msg";
import { form2Submit, form2Submitted } from "../../actions/forms";
import {
    consumeCaptchaToken, isCaptchaError, normalizeEmail, requireCaptchaAfterAttempt
} from '../../helpers/security';
import PublicFormProtection from '../Security/PublicFormProtection';

//CSS
import './bolsatrabajo.css'

//MUI
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, Container, Grid, Typography, useMediaQuery  } from '@mui/material'

const name_regex = /^([^0-9]*)$/;
const email_regex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
const tel_regex = /^[0-9]*$/;

// valores de formulario
const init = {
    name: '',
    lastname: '',
    email: '',
    tel: '',
    file: '',
    website: ''
};

// errores en campos
const initErr = {
    name_err: false,
    lastname_err: false,
    email_err: false,
    tel_err: false,
};

const BolsaTrabajoComponent = () => {
    const matches = useMediaQuery('(max-width: 950px)')
    const dispatch = useDispatch();
    const { form2, form2Loading } = useSelector(state => state.form);
    // campos
    const [values, setValues] = useState(init);
    const { name, lastname, email, tel, file, website } = values;
    const [security, setSecurity] = useState({ required: false, token: '', key: 0 });
    // errores en campos
    const [inputErr, setInputErr] = useState(initErr);
    const { name_err, lastname_err, email_err, tel_err } = inputErr;
    const [isFilePicked, setIsFilePicked] = useState(false);
    // referencias a campos
    const name_ref = useRef();
    const lastname_ref = useRef();
    const tel_ref = useRef();
    const email_ref = useRef();

    useEffect(() => {
        dispatch(form2Submitted(false));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (form2) {
            setValues({
                name: '',
                lastname: '',
                email: '',
                tel: '',
                file: '',
                website: ''
            });
            setSecurity({ required: false, token: '', key: 0 });
            dispatch(form2Submitted(false));
            setButton(false);
            setIsFilePicked(false);
        }
    }, [form2]); // eslint-disable-line react-hooks/exhaustive-deps

    const changeHandler = ({ target }) => {
        const selected = target.files[0];
        const allowed = selected && [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ].includes(selected.type);
        if (!allowed || selected.size > 5 * 1024 * 1024) {
            basicMsg('El CV debe ser PDF, DOC o DOCX y pesar como máximo 5 MB');
            target.value = '';
            return;
        }
        setValues(e => ({
            ...e,
            file: selected
        })
        );
        //setSelectedFile(event.target.files[0]);
        setIsFilePicked(true);
        setButton(true)
    };

    const deleteFile = () => {
        setValues(e => ({
            ...e,
            file: ''
        })
        );
        //setSelectedFile("");
        setIsFilePicked(false);
        setButton(false)
    }

    const [button, setButton] = useState(false);
    const ButtonDeleteFile = () => {
        return (
            <>
                <Link
                    to={""}
                    style={{ color: 'red' }}
                    onClick={deleteFile}
                >
                    <i className="fa-solid fa-xmark"></i>
                </Link>
            </>
        )
    };

    const handleInputChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (name === 'name' || name === 'lastname') {
            if (value === '' || name_regex.test(value)) {
                setValues(e => ({
                    ...e,
                    [name]: value
                })
                );
            }
        } else if (name === 'tel') {
            if (value === '' || tel_regex.test(value)) {
                setValues(e => ({
                    ...e,
                    [name]: value
                })
                );
            }
        } else setValues(e => ({
            ...e,
            [name]: value
        })
        );
        switch (name) {
            case 'name':
                setInputErr({
                    ...inputErr,
                    name_err: value.length < 2 || value.length > 50
                });
                break;
            case 'lastname':
                setInputErr({
                    ...inputErr,
                    lastname_err: value.length < 2 || value.length > 50
                });
                break;
            case 'tel':
                setInputErr({
                    ...inputErr,
                    tel_err: (value.length < 3 ||
                        value.length > 20) ? true : false
                });
                break;
            case 'email':
                setInputErr({
                    ...inputErr,
                    email_err: (value.length < 6 ||
                        value.length > 120) ? true : false
                });
                break;
            default:
                break;
        }
    };

    // envío de formulario
    const submit = async (e) => {
        e.preventDefault();
        if (formValidator()) {
            const token = security.token;
            if (token) setSecurity(current => consumeCaptchaToken(current, token));
            const body = await dispatch(form2Submit({
                ...values,
                email: normalizeEmail(email)
            }, token));
            if (isCaptchaError(body)) setSecurity(current =>
                requireCaptchaAfterAttempt(current, token));
        }
    };

    // validación básica de formulario
    const formValidator = () => {
        const name_len = name.trim().length;
        if (name_len > 1 && name_len <= 50) {
            const lastname_len = lastname.trim().length;
            if (lastname_len > 1 && lastname_len <= 50) {
            const email_len = email.trim().length;
            if (email_len > 5 && email_len <= 120 && email_regex.test(email)) {
                const tel_len = tel.trim().length;
                if (tel_len > 2 && tel_len <= 20) {
                    if (file !== '') return true;
                    else basicMsg('Añada su CV (.pdf/.docx)');
                } else {
                    tel_ref.current.select();
                    setInputErr({
                        ...inputErr,
                        tel_err: true
                    });
                }
            } else {
                email_ref.current.select();
                setInputErr({
                    ...inputErr,
                    email_err: true
                });
            }
            } else {
                lastname_ref.current.select();
                setInputErr({ ...inputErr, lastname_err: true });
            }
        } else {
            name_ref.current.select();
            setInputErr({
                ...inputErr,
                name_err: true
            });
        }
        return false;
    };

    return (
        <>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={form2Loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            {/* Title */}
            <Container maxWidth='xl' sx={{ mt: matches ? 5 : 18 }}>
                <Typography variant='h4' sx={{ fontWeight: 'light' }} align='center'>ÚNETE A NUESTRO EQUIPO.</Typography>
            </Container>

            {/* Contenido */}
            <Container maxWidth='xl' sx={{ mt: 5 }} className="last-view">
                <Typography variant='body1' paragraph>Apoyamos y motivamos a nuestros colaboradores a crecer en más de una
                    dimensión y a explotar todo su potencial tanto personal como profesional
                    logrando un crecimiento, balance intelectual, emocional y social que te
                    llevará a sentirte completamente satisfecho. Buscamos ser la una de las
                    mejores empresas para trabajar.</Typography>

                <Typography variant='body1' paragraph>Gracias al talento de cada uno de sus colaboradores, Nefrópolis es una empresa
                    sólida, y con presencia a nivel nacional. Por ello, te invitamos a que hagas
                    carrera con nosotros, que te desarrolles y te realices plenamente.
                    <b> Esperamos tener un lugar para ti</b></Typography>

                <Typography variant='body1' paragraph><b>Coord. de Capital humano.</b></Typography>

                {/* Formulario */}
                <Box sx={{ p: 3, mt: 5 }} className="box-nuestro-equipo">
                    <form action="">
                        <Grid container spacing={3}>
                            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        id=""
                                        name="name"
                                        label="Nombre"
                                        type="text"
                                        placeholder="Nombre"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <i className="fa-solid fa-user"></i>
                                                </InputAdornment>
                                            ),
                                        }}
                                        variant="standard"
                                        inputProps={{ maxLength: 50 }}
                                        error={name_err}
                                        helperText={name_err ? "Ingrese su nombre" : ""}
                                        inputRef={name_ref}
                                        value={name}
                                        onChange={handleInputChange} />
                                </FormControl>
                            </Grid>

                            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        name="lastname"
                                        label="Apellido"
                                        type="text"
                                        placeholder="Apellido"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <i className="fa-solid fa-user"></i>
                                                </InputAdornment>
                                            ),
                                        }}
                                        variant="standard"
                                        inputProps={{ maxLength: 50 }}
                                        error={lastname_err}
                                        helperText={lastname_err ? "Ingrese su apellido" : ""}
                                        inputRef={lastname_ref}
                                        value={lastname}
                                        onChange={handleInputChange} />
                                </FormControl>
                            </Grid>

                            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        id=""
                                        name="email"
                                        label="Correo electrónico"
                                        type="mail"
                                        placeholder="Correo electrónico"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <i className="fa-solid fa-envelope"></i>
                                                </InputAdornment>
                                            ),
                                        }}
                                        variant="standard"
                                        inputProps={{ maxLength: 120 }}
                                        error={email_err}
                                        helperText={email_err ? "Ingrese su correo electrónico" : ""}
                                        inputRef={email_ref}
                                        value={email}
                                        onChange={handleInputChange}
                                        onBlur={() => setValues(current => ({
                                            ...current, email: normalizeEmail(current.email)
                                        }))} />
                                </FormControl>
                            </Grid>

                            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        id=""
                                        name="tel"
                                        label="Teléfono"
                                        type="text"
                                        placeholder="Teléfono"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <i className="fa-solid fa-phone"></i>
                                                </InputAdornment>
                                            ),
                                        }}
                                        variant="standard"
                                        inputProps={{ maxLength: 20 }}
                                        error={tel_err}
                                        helperText={tel_err ? "Ingrese su número de teléfono" : ""}
                                        inputRef={tel_ref}
                                        value={tel}
                                        onChange={handleInputChange} />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                    <Box sx={{ mr: 1 }}>
                                        <Button
                                            variant="contained"
                                            component="label"
                                        >
                                            Subir archivo
                                            <input
                                                accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.doc,.docx"
                                                type="file"
                                                hidden
                                                onChange={changeHandler}
                                            />
                                        </Button>
                                    </Box>

                                    <Box sx={{ my: 'auto' }}>
                                        {isFilePicked ? (
                                            <div>
                                                {file.name}
                                            </div>
                                        ) : null}
                                    </Box>

                                    <Box sx={{ my: 'auto', ml: 1 }}>
                                        {button ?
                                            < ButtonDeleteFile ></ButtonDeleteFile>
                                            : null}
                                    </Box>
                                </Box>
                                <Typography variant='body2' sx={{ fontWeight: 'light', mt: .5 }}>
                                    Carga tu CV en formato pdf o word
                                </Typography>
                            </Grid>
                        </Grid>

                        <PublicFormProtection
                            website={website}
                            onWebsiteChange={handleInputChange}
                            captchaRequired={security.required}
                            captchaKey={security.key}
                            action="postulation"
                            onVerify={token => setSecurity(current => ({ ...current, token }))}
                        />
                        <Button variant='contained' onClick={submit} sx={{ mt: 2 }}>Enviar</Button>
                    </form>
                </Box>
                {/* Fin formulario */}

                <Box sx={{ mt: 6, textAlign: 'center' }}>
                    <Typography variant='h5' sx={{ fontWeight: 'light' }} gutterBottom>CONOCE NUESTRO CÓDIGO DE ÉTICA</Typography>
                    <Link to="/codigo-de-etica">
                        <i className="fa-solid fa-arrow-up-right-from-square" style={{ fontSize: '1.8rem' }}></i>
                    </Link>
                </Box>

            </Container>
            {/* Fin contenido */}
        </>
    )
}

export default BolsaTrabajoComponent
